<loader-overlay-component [show]="isloading"></loader-overlay-component>

    <div class="dmv-search-results inner-home">
        <div class="container">
            <div class="row no-margin">
                <div class="col-6 col-sm-2 mt-4 "><a><button (click)="back()" class="btn btn-primary btn-back top-back-button"><i
                                class="fa fa-chevron-left text-left"></i> Back</button></a></div>
                <div class="col-12 col-sm-8 mt-4">
                    <div id="searchResu">Log In to MyEasyGov</div>
                    <p id="addthereco"><span>&nbsp;</span></p>
                </div>
                <div class="col-6 col-sm-2 icon-cart mt-4">

                </div>

                <div class="col-12 alert alert-danger" role="alert" *ngIf="errorMessage" > &nbsp;<span [innerHTML]="errorMessage"></span></div>
                          
                <form autocomplete="off" class="w100 text-left mb-b" [formGroup]="logInForm">
                    <div class="row">
                        <div class="col-12 col-sm-6 m-auto">
                            <div class="col-12 asteriskMessage"> *Fields marked with an asterisk are required </div>

                            <div class="row no-margin">
                                <div class="col-12 col-sm-12 mb-4">
                                    <label  class="lblPin">Email Address*</label><input (blur)="globalService.trimValue(f.emailAddress)"  class="form-control" formControlName="emailAddress" [ngClass]="{ 'is-invalid': submitted && f.emailAddress.errors }">
                                    <div *ngIf="submitted && f.emailAddress.errors && f.emailAddress.errors.required"  class="invalid-feedback">Email Address is required.</div>
                                        <div *ngIf="submitted && f.emailAddress.errors && f.emailAddress.errors.pattern"  class="invalid-feedback">Please enter valid email address.</div>
                                </div>
                                <div class="col-12 col-sm-12 mb-4">
                                    <label  class="lblPin">Password*</label><input type="password" class="form-control" formControlName="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                                    <div *ngIf="submitted && f.password.errors && f.password.errors"  class="invalid-feedback">Please enter password.</div>
                                </div>
                                <div class="col-12 col-sm-12 mb-4">
                                    <div class="textLink" (click)="forgotPassword()">Forgot your password?</div>
                                </div>
                                <div class="col-12 col-sm-12 mb-4">
                                    <div class="textLink" (click)="registerNewUser()">Enroll as new user</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="container m-auto text-center">
                <a><button class="btn btn-primary btn-back" (click)="cancel()" > Cancel</button></a><a><button
                        class="btn btn-primary  btn-continue m-auto" (click)="logIn()">Log In </button></a></div>

        </div>


    </div>
